<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon color="purple" class="mr-2">mdi-robot-outline</v-icon>AI insights
      <v-spacer />
      <v-btn small color="purple" dark class="text-none" :loading="loading" @click="generate">
        {{ result ? 'Regenerate' : 'Generate' }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div v-if="!result && !loading && !error" class="caption grey--text">
        Generate a team summary for {{ range.from === 'all' ? 'all time' : range.from + ' → ' + range.to }}.
      </div>
      <v-alert v-if="error" type="warning" dense outlined>
        Insights unavailable. {{ error }}
        <v-btn small text @click="generate">Retry</v-btn>
      </v-alert>
      <div v-if="result">
        <div class="body-2 mb-3">{{ result.summary }}</div>
        <div v-for="s in sections" :key="s.key">
          <template v-if="(result[s.key] || []).length">
            <div class="caption font-weight-bold" :class="s.color + '--text'">{{ s.label }}</div>
            <ul class="body-2 mb-2"><li v-for="(t, i) in (result[s.key] || [])" :key="i">{{ t }}</li></ul>
          </template>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getInsights } from '@/services/adminGrowthService'

export default {
  name: 'AdminInsightsPanel',
  props: { range: { type: Object, required: true } },
  data() {
    return {
      result: null, loading: false, error: null,
      sections: [
        { key: 'strengths', label: 'Strengths', color: 'success' },
        { key: 'risks', label: 'Risks', color: 'error' },
        { key: 'actions', label: 'Suggested actions', color: 'primary' },
      ],
    }
  },
  watch: {
    range: {
      handler() {
        this.reqId++ // supersede any in-flight request for the old period
        this.loading = false; this.result = null; this.error = null
      },
      deep: true,
    },
  },
  created() {
    this.reqId = 0 // non-reactive request counter
  },
  methods: {
    async generate() {
      const id = ++this.reqId
      this.loading = true; this.error = null
      try {
        const data = await getInsights({ from: this.range.from, to: this.range.to })
        if (id !== this.reqId) return
        this.result = data
      } catch (e) {
        if (id !== this.reqId) return
        this.error = e.message
      } finally {
        if (id === this.reqId) this.loading = false
      }
    },
  },
}
</script>
